<div class="dropdown country-selector" [class.show]="dropdownOpen">
  <button
    class="btn btn-light dropdown-toggle w-100 d-flex align-items-center justify-content-between shadow-sm"
    type="button"
    (click)="toggleDropdown()"
  >
    <div class="d-flex align-items-center gap-2">
      <img
        [src]="getFlag(selectedSite)"
        width="24"
        height="18"
        class="rounded"
        *ngIf="selectedSite.name"
        [alt]="selectedSite.name + ' flag'"
      />
      <span>{{ selectedSite.name || 'Select a site' }}</span>
      </div>
  </button>
  <ul class="dropdown-menu w-100 shadow-sm border-light py-1" [class.show]="dropdownOpen">
    <li *ngFor="let site of sites">
      <button
        (click)="selectSite(site)"
        class="dropdown-item py-2 px-3 d-flex align-items-center gap-3"
      >
      <img *ngIf="site?.name" [src]="getFlag(site)" width="20" height="15" [alt]="site?.name + ' flag'" />
        <span>{{ site.name }}</span>
      </button>
    </li>
  </ul>
</div>

<style>
.country-selector .dropdown-toggle {
  padding: 0.625rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
}

.country-selector .dropdown-toggle::after {
  margin-left: 0.5rem;
}

.country-selector .dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  border-radius: 0.375rem;
}

.country-selector .dropdown-item {
  cursor: pointer;
  border-radius: 0.25rem;
  transition: background-color 0.15s ease-in-out;
}

.country-selector .dropdown-item:hover {
  background-color: rgba(13, 110, 253, 0.1);
}
</style>